enum DeepLinkingUrls {
  DEEP_LINK_PERKBOX_MEDICAL_IOS = "perkboxMedical://",
  LINK_TO_STORE_PERKBOX_MEDICAL_IOS = "https://itunes.apple.com/gb/app/perkbox-medical/id1436187039?mt=8",
  DEEP_LINK_PERKBOX_MEDICAL_ANDROID = "com.perkbox.medical",
  LINK_TO_STORE_PERKBOX_MEDICAL_ANDROID = "https://play.google.com/store/apps/details?id=com.perkbox.medical&hl=en_GB"
}

export default DeepLinkingUrls
